import { APP_CONFIG } from "../../constant/common";
import { localStorageName } from "../../enums/common";
import { isConfigFlagEnabled } from "../../helpers/configFlags";
import { getItemFromLocalStorage } from "../../hooks/localStorage";
import { iAppConfig } from "../../types/common";
import { consoleLog } from "../consoleLog/consoleLog";

const STORAGE_KEY = "_zenvoya_requested_itinerary_id";

const isFlagOn = (): boolean => {
  const appConfig = getItemFromLocalStorage(localStorageName.TripTroveAppConfig) as iAppConfig[] | null;
  return isConfigFlagEnabled(appConfig, APP_CONFIG.SEND_REQUESTED_ITINERARYID);
};

export function rememberRequestedItineraryId(value: unknown): void {
  if (!isFlagOn()) return;
  const id = typeof value === "string" ? value.trim() : "";
  if (!id) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, id);
  } catch {
    consoleLog(["REQUESTED ITINERARY ID: storage unavailable; the next prebook call will send none"]);
  }
}

export function getRequestedItineraryIdField(): { requestedItineraryId?: string } {
  try {
    if (!isFlagOn()) return {};
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? { requestedItineraryId: stored } : {};
  } catch {
    return {};
  }
}
